import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { taskBoardApiRef, TaskBoardClient } from './api';

export const taskBoardPlugin = createPlugin({
  id: 'task-board',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: taskBoardApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new TaskBoardClient(discoveryApi, fetchApi),
    }),
  ],
});

export const TaskBoardPage = taskBoardPlugin.provide(
  createRoutableExtension({
    name: 'TaskBoardPage',
    component: () =>
      import('./components/TaskBoardPage').then(m => m.TaskBoardPage),
    mountPoint: rootRouteRef,
  }),
);
